import DailyCosts from '@/api/admin/dailyCosts.service'

export default {
  state: {
    table: {
      pageLength: 10,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      dateFrom: null,
      dateTo: null,
      filterParams: {},
    },
  },
  getters: {
    allDailyCosts: state => state.table,
    getDateRange: state => ({
      dateFrom: state.table.dateFrom,
      dateTo: state.table.dateTo,
    }),
    getFilterParams: state => ({ filterParams: state.table.filterParams }),
  },
  actions: {
    async getDailyCosts({ commit, state }) {
      const {
        filterParams,
      } = state.table
      const skip = (state.table.currentPage - 1) * state.table.pageLength
      const filter = {
        skip,
        take: state.table.pageLength,
        dateFrom: state.table.dateFrom,
        dateTo: state.table.dateTo,
        filterParams,
      }

      const dailyCosts = await DailyCosts.getDailyCosts(filter)
      commit('SET_TOTALRECORDS', dailyCosts.totalCount)
      commit('SET_DAILYCOSTS', dailyCosts.values)
    },
  },
  mutations: {
    SET_DAILYCOSTS(state, dailyCosts) {
      state.table.rows = dailyCosts
    },
    SET_TOTALRECORDS(state, totalRecords) {
      state.table.totalRecords = totalRecords
    },
    SET_CURRENT_PAGE_DC(state, newPage) {
      state.table.currentPage = newPage
    },
    SET_DATE_RANGE(state, { dateFrom, dateTo }) {
      state.table.dateFrom = dateFrom
      state.table.dateTo = dateTo
    },
    SET_FILTER_PARAMS(state, filterParams) {
      state.table.filterParams = filterParams
    },
  },
}
